module.exports = "./img/6b32266eb4c78c6f241aa85fa4982ae1.jpg";